import HelpMenu from "./HelpMenu";
import {
	FooterContainer,
	FooterGdprText,
	FooterItems,
	FooterUtils,
	FooterYear,
	FooterUtilDivide,
} from "./style";

const Footer = () => {
	return (
		<FooterContainer>
			<FooterItems>
				<HelpMenu />
				<FooterUtils>
					<FooterGdprText>KVKK</FooterGdprText>
					<FooterUtilDivide />
					<FooterYear>{new Date().getFullYear()}</FooterYear>
				</FooterUtils>
			</FooterItems>
		</FooterContainer>
	);
};

export default Footer;
